import { createSlice } from "@reduxjs/toolkit";
import { createJson, createResponseConfig } from "../../components/builder/api-report/editor/code/helpers/codeHelper";
import type { ApiReportActionTypes, ApiReportState } from "../types/apiReportState.types";
import { API_REPORT_SLICE_NAME } from "../utils/storeUtils";

const initialState: ApiReportState = {
  responseJson: "",
};

export const apiReportSlice = createSlice({
  name: API_REPORT_SLICE_NAME,
  initialState,
  reducers: {
    setResponse: (state, action: ApiReportActionTypes["setResponse"]) => {
      state.responseJson = createJson(createResponseConfig(action.payload));
    },
  },
});

export default apiReportSlice.reducer;
